import React from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function TextEditor({ value, onChange, refState }) {
  const handleEditorChange = (content, editor) => {
    if (refState) {
      refState.current = editor;
    }
    if (onChange) {
      onChange(content);
    }
  };

  return (
    <Editor
      apiKey="xzvyhdr3g51rxde6ka5g9pafsyhtsh7lmev9vq6fjdigaymv"
      value={value}
      onEditorChange={handleEditorChange}
      init={{
        height: 300,
        menubar: false,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "preview",
          "anchor",
          "searchreplace",
          "visualblocks",
          "code",
          "fullscreen",
          "insertdatetime",
          "media",
          "table",
          "code",
          "help",
          "wordcount",
          "code",
        ],
        toolbar:
          "undo redo | blocks | " +
          "bold italic forecolor | alignleft aligncenter " +
          "alignright alignjustify | bullist numlist outdent indent | " +
          "link removeformat | code",
        content_style: `
          body {
            font-family: Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            line-height: 1.6 !important;
          }
          p {
            margin-bottom: 1em !important;
            font-size: 14px !important;
          }
          h1, h2, h3, h4, h5, h6 {
            margin-top: 1.5em !important;
            margin-bottom: 0.5em !important;
            font-size: 24px !important;
          }
          a {
            color: #3598db !important;
            text-decoration: none !important;
          }
          strong {
            font-weight: bold !important;
          }
        `,
      }}
    />
  );
}
